import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Red bar shown to every user of a company whose workspace deletion is scheduled.
export const CompanyDeletionBanner = () => {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!user?.company_id) return;
    axios.get(`${API}/company/deletion-status`, { withCredentials: true }).then((r) => setStatus(r.data)).catch(() => {});
  }, [user?.company_id, user?.id]);

  if (!status?.scheduled) return null;
  const date = new Date(status.purge_at).toLocaleDateString();
  return (
    <div data-testid="company-deletion-banner" className="bg-red-600 text-white px-4 py-2 text-xs sm:text-sm font-semibold flex flex-wrap items-center justify-center gap-2"
      style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
      <AlertTriangle className="w-4 h-4" />
      <span>This company workspace will be permanently deleted on {date}.</span>
      {status.can_cancel && (
        <Link to="/company/reset" className="underline hover:no-underline" data-testid="company-deletion-banner-manage">Manage / cancel</Link>
      )}
    </div>
  );
};

export default CompanyDeletionBanner;
